import {Button} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {faArrowRight, faBolt} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import React from 'react';

interface Props {
  bannerWidth?: string;
  bannerHeight?: string;
  left?: string;
  top?: string;
  isKmt?: boolean;
  bottom?: string;
  noBackground?: boolean;
  text?: string;
  color?: string;
}

export const ChartOverlayBanner:React.FC<Props> = observer(({color='#1FAC47', text='Get a 7 Day trial for Free to see more', noBackground=false, bannerWidth='60%', bannerHeight='90%', left='40px', top='', isKmt, bottom}) => {
  const {settings: {customer: {setAuthModal}}} = useStore('');

  return (<Container noBackground={noBackground} bannerHeight={bannerHeight} bannerWidth={bannerWidth} left={left} top={top} isKmt={isKmt} bottom={bottom}>
    <IconContainer color={color}>
      <FontAwesomeIcon icon={faBolt} color={color}/>
    </IconContainer>
    <Heading isKmt={isKmt}>{text}</Heading>
    {isKmt && <RequestWrapper>Please upgrade your subscription to expand <div>your possibilities. </div></RequestWrapper>}
    <Button color={color == '#1FAC47' ? 'green' : 'purple'} onClick={() => setAuthModal(true, false)}>7 Day Free Trial&nbsp;<FontAwesomeIcon icon={faArrowRight}/></Button>
    {isKmt && <LogIn onClick={() => setAuthModal(true, true)}>Log in</LogIn>}
  </Container>);
});


const Container = styled.div<{bannerHeight: string; bannerWidth: string; left: string; top: string; isKmt: boolean; bottom: string; noBackground: boolean}>`
  width: ${p => p.bannerWidth};
  height: ${p => p.bannerHeight};
  border-radius: 10px;
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  ${p=> p?.top ? `top: ${p?.top}` : ''};
  position: absolute;
  bottom: ${p=> p?.bottom ? p?.bottom : '20px'};
  left: ${p => p.left};
  z-index: 1;
  background: ${p => p.noBackground ? 'transparent' : 'rgba(255, 255, 255, 0.6)'};
  ${p => p.noBackground ? '' : 'backdrop-filter: blur(12.5px)'};
  align-items: center;
  justify-content: ${P=> P?.isKmt ? 'center' : 'space-evenly'};
  z-index: 10;
`;

const IconContainer = styled.div<{color: string}>`
  width: 46px;
  height: 46px;
  background: ${p => `${p.color}26`};
  font-size: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Heading = styled.div<{isKmt?: boolean}>`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #121212;
  margin-top: ${p=> p?.isKmt ? '19px' : '0'};
`;
const RequestWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 16px 0 29px 0;
  line-height: 17px;
  text-align: center;
  color: #4E5156;
`;
const LogIn = styled.div`
  margin-top: 19px;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  color: #2D6CCA;
  cursor: pointer;
`;
